import MergeCompanies from "./MergeCompanies";

export default function MergeCompaniesPage() {
  return <MergeCompanies />;
}
